import { useEffect, useState } from "react";
import { DownloadSimple } from "@phosphor-icons/react";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { toast } from "sonner";

const PDF_NAME = "REEDOS_Attendance_Regularisation_Employee_User_Guide.pdf";

async function downloadGuide() {
    try {
        const resp = await api.get("/attendance/user-guide", { params: { format: "pdf" }, responseType: "blob" });
        const url = URL.createObjectURL(new Blob([resp.data], { type: "application/pdf" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = PDF_NAME;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) {
        toast.error(formatApiError(e, "Download failed"));
    }
}

export function UserGuideDialog({ open, onClose }) {
    const [html, setHtml] = useState(null);
    useEffect(() => {
        if (!open || html) return;
        api.get("/attendance/user-guide", { responseType: "text" })
            .then((r) => setHtml(r.data))
            .catch((e) => toast.error(formatApiError(e, "Could not load the user guide")));
    }, [open, html]);
    if (!open) return null;
    return (
        <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-5xl w-[96vw] p-0 gap-0" data-testid="user-guide-dialog">
                <DialogHeader className="flex flex-row items-center justify-between gap-3 px-5 py-3 border-b">
                    <div>
                        <DialogTitle>User Guide</DialogTitle>
                        <DialogDescription>Attendance Regularisation — Employee User Guide</DialogDescription>
                    </div>
                    <Button variant="outline" size="sm" className="mr-8" onClick={downloadGuide} data-testid="user-guide-download">
                        <DownloadSimple size={14} className="mr-1" /> Download User Guide PDF
                    </Button>
                </DialogHeader>
                {html
                    ? <iframe title="Employee User Guide" srcDoc={html} sandbox="" className="w-full h-[78vh] rounded-b-lg" data-testid="user-guide-frame" />
                    : <div className="h-[78vh] flex items-center justify-center text-sm text-slate-500">Loading…</div>}
            </DialogContent>
        </Dialog>
    );
}
